export interface FileData {
  key: string;
  name: string;
  date: string;
  size: string;
  owner: string;
}

// NOTE: 임시 데이터
export const dataSource: FileData[] = [
  {
    key: '1',
    name: 'crython guardians Team Meeting',
    date: '24.08.01',
    size: '1.2mb',
    owner: 'user001',
  },
  {
    key: '2',
    name: 'API 명세서',
    date: '24.08.02',
    size: '9.8mb',
    owner: 'user002',
  },
  {
    key: '3',
    name: '프로젝트 계획서',
    date: '24.08.03',
    size: '8.5mb',
    owner: 'user003',
  },
  {
    key: '4',
    name: '개발 일정 보고서',
    date: '24.08.04',
    size: '1.5mb',
    owner: 'user004',
  },
  {
    key: '5',
    name: '프레젠테이션 자료',
    date: '24.08.05',
    size: '1.3mb',
    owner: 'user005',
  },
  {
    key: '6',
    name: '디자인 시안',
    date: '24.08.06',
    size: '6.7mb',
    owner: 'user006',
  },
  {
    key: '7',
    name: '포트폴리오',
    date: '24.08.07',
    size: '1.5mb',
    owner: 'user123',
  },
  {
    key: '8',
    name: '제품 설명서',
    date: '24.08.08',
    size: '1.2mb',
    owner: 'user007',
  },
  {
    key: '9',
    name: '연구 논문',
    date: '24.08.09',
    size: '2mb',
    owner: 'user008',
  },
  {
    key: '10',
    name: '시장 분석',
    date: '24.08.10',
    size: '1.7mb',
    owner: 'user009',
  },
  {
    key: '11',
    name: '마케팅 전략',
    date: '24.08.11',
    size: '1.1mb',
    owner: 'user010',
  },
  {
    key: '12',
    name: '예산 계획',
    date: '24.08.12',
    size: '1.4mb',
    owner: 'user011',
  },
  {
    key: '13',
    name: '회의록',
    date: '24.08.13',
    size: '5mb',
    owner: 'user012',
  },
  {
    key: '14',
    name: '계약서',
    date: '24.08.14',
    size: '3mb',
    owner: 'user013',
  },
  {
    key: '15',
    name: '제안서',
    date: '24.08.15',
    size: '8.2mb',
    owner: 'user014',
  },
  {
    key: '16',
    name: '프로그래밍 가이드',
    date: '24.08.16',
    size: '7.3mb',
    owner: 'user015',
  },
  {
    key: '17',
    name: '데이터 분석 보고서',
    date: '24.08.17',
    size: '2.1mb',
    owner: 'user016',
  },
  {
    key: '18',
    name: '프로젝트 보고서',
    date: '24.08.18',
    size: '1.6mb',
    owner: 'user017',
  },
  {
    key: '19',
    name: '사용자 매뉴얼',
    date: '24.08.19',
    size: '1.4mb',
    owner: 'user018',
  },
  {
    key: '20',
    name: '최종 발표 자료',
    date: '24.08.20',
    size: '9.5mb',
    owner: 'user019',
  },
];
